import { useLocation } from '@reach/router';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { useSite } from '../contexts/SiteContext';
import * as Styles from './article-sign-up-embed.module.scss';

function ArticleSignUpEmbed() {
  const location = useLocation();
  const { setStashURL } = useSite();

  function handleSignUp() {
    setStashURL(location.pathname);
  }

  return (
    <div className={Styles.root}>
      <div className={Styles.content}>
        <div className={Styles.icon}>
          <StaticImage
            src="../assets/components/article-sign-up-embed/shield.png"
            alt=""
            layout="fixed"
            width={177}
            height={214}
            className={Styles.icon}
          />
        </div>
        <div>
          <div className={Styles.header}>Customize Your Experience</div>
          <Link to="/sign-up" onClick={() => handleSignUp()}>
            Sign up
          </Link>{' '}
          for a FREE account to access a personalized Your 🔥 Job experience and Tool Kit.
          <div>
            <div className={Styles.tfk}>
              Fueled by{' '}
              <StaticImage
                className={Styles.tfk__image}
                alt="Time for Kids"
                layout="fixed"
                width={84}
                height={13}
                src="../assets/components/article-sign-up-embed/time-for-kids.png"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ArticleSignUpEmbed;
